$(document).ready(function(){
  let cart = $.getJSON('/cart.js'); 
  cart.done(function(){
    cart = cart.responseJSON;
    console.log('disable_product',cart);
    if(cart.total_price < 5000){
      $('.cart-product-wrapper').addClass('disable_product');
      $('.free-product').each(function(){
        $(this).find('cart-remove-button').trigger('click');
      });
    }else{
      $('.cart-product-wrapper').removeClass('disable_product');
    }
    
    $('.free-product').each(function(){
      $(this).find('.cart-item__quantity input').prop('readonly', true);
    });
    
    
    var ItemCount = $('.free-product').length;      
    if(ItemCount == "2"){
      $('.cart-product-wrapper').addClass('disable_product');
      $('.free-product').each(function(){
        $(this).find('.quantity__button').css('pointer-events','none')
      });
    }

    var FreeProductQuantity =  $('.free-product .quantity__input').val();
    if(FreeProductQuantity >= "2"){
      $('.cart-product-wrapper').addClass('disable_product');
      if(FreeProductQuantity >= "2"){
        $('.free-product').each(function(){
          $(this).find('.quantity__button[name="plus"]').css('pointer-events','none')
        });
      }
    }
    
  });
});

// Cart page
$(document).ready(function(){

  
  
  $('.cart__note label').click(function(){
    $(this).next().show();
  });
});